import { render, staticRenderFns } from "./AI.vue?vue&type=template&id=3741c9bc&scoped=true&"
import script from "./AI.vue?vue&type=script&lang=ts&"
export * from "./AI.vue?vue&type=script&lang=ts&"
import style0 from "./AI.vue?vue&type=style&index=0&id=3741c9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3741c9bc",
  null
  
)

export default component.exports